import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { ParentPaper } from '../../atoms/parent-paper';
import { ButtonBox } from '../../molecules/button-box';

import { Group } from '../../organisms/group';
import { ServiceAccessInput } from '../../organisms/settings/service-access-input';
import { useSelector } from '../../store/utils';

import { trpc } from '../../api/trpc';
import { links } from '../../paths';

const DevAppMessages = () => {
  const navigate = useNavigate();

  const [serviceActive] = useSelector(
    ({ variables }) => [variables.SERVICE_ACTIVE] as const
  );

  const { mutate } = trpc.testAppMessage.useMutation({
    onSuccess: () => {
      navigate(links.appMessages);
    },
  });

  if (!serviceActive) {
    return (
      <Group
        layout="list"
        title={
          <FormattedMessage
            id="dev_homepage.app_messages.title"
            defaultMessage="Notifikace"
          />
        }
      >
        <ServiceAccessInput />
      </Group>
    );
  }

  return (
    <Group
      layout="list"
      title={
        <FormattedMessage
          id="dev_homepage.app_messages.title"
          defaultMessage="Notifikace"
        />
      }
    >
      <ParentPaper>
        <ButtonBox
          title={
            <FormattedMessage
              id="dev_app_messages.test_send"
              defaultMessage="Testovací notifikace"
            />
          }
          buttonLabel={
            <FormattedMessage
              id="dev_app_messages.test_send.button"
              defaultMessage="Odeslat"
            />
          }
          onClick={() => mutate()}
          fullWidth
        />
      </ParentPaper>
    </Group>
  );
};

export default DevAppMessages;
